import { socialLinks } from 'config/constants/socialLinks';

export const home = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare',
  url: 'https://www.boldare.com/',
  sameAs: Object.values(socialLinks),
  areaServed: 'Worldwide',
  email: [
    'hello@boldare.com',
    'career@boldare.com',
    'media@boldare.com',
    'business@boldare.com',
  ],
  description:
    "At Boldare, we go beyond just discussing great products - we create them with our clients. Explore our case studies to see how we've helped launch outstanding AI-powered solutions on the market, all while upholding our high quality service standards.",
  address: [
    {
      '@type': 'PostalAddress',
      streetAddress: 'Zwycięstwa 52',
      addressLocality: 'Gliwice',
      postalCode: '44-100',
      addressCountry: 'PL',
    },
    {
      '@type': 'PostalAddress',
      streetAddress: 'Krucza 50',
      addressLocality: 'Warszawa',
      postalCode: '00-025',
      addressCountry: 'PL',
    },
    {
      '@type': 'PostalAddress',
      streetAddress: 'Wyspa Słodowa 7',
      addressLocality: 'Wrocław',
      postalCode: '50-266',
      addressCountry: 'PL',
    },
    {
      '@type': 'PostalAddress',
      streetAddress: 'Kurniki 9',
      addressLocality: 'Kraków',
      postalCode: '31-156',
      addressCountry: 'PL',
    },
  ],
};
